// extracted by mini-css-extract-plugin
export var bio = "faculty-diapo-module--bio--17658";
export var bioActive = "faculty-diapo-module--bioActive--72842";
export var biography = "faculty-diapo-module--biography--754b2";
export var button = "faculty-diapo-module--button--4892b";
export var job = "faculty-diapo-module--job--ffddc";
export var main = "faculty-diapo-module--main--c10f0";
export var separator = "faculty-diapo-module--separator--addd2";
export var title = "faculty-diapo-module--title--05c1b";